import { render, staticRenderFns } from "./ClassChoose.vue?vue&type=template&id=7e1260e8&"
import script from "./ClassChoose.vue?vue&type=script&lang=js&"
export * from "./ClassChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports